import { create } from "zustand";
import type { UserBasicApi } from "api/models/user";


export type UserAccount = Omit<UserBasicApi, "id"> & { id?: number };

type UserState = {
	user: UserAccount;
	profileId: string;

	setUser: (v: UserAccount) => void;
	setUserFromQuery: (id: number, name: string) => void;
	setProfile: (v: string) => void;
};

export const useStoreUser = create<UserState>((set) => ({
	user: { name: "" },
	profileId: "",

	setUser: (user) => set(() => ({ user })),
	setUserFromQuery: (id, name) => set(() => ({ user: { id, name } })),
	setProfile: (profileId) => set(() => ({ profileId }))
}));